import { Plus } from "lucide-react";
import { Group, Field, SaveBar, RowTools, move, useDraft, useSectionSave } from "./shared";

export const PaymentsSection = () => {
  const { settings, save, busy } = useSectionSave();
  const [list, setList] = useDraft(settings.payment_methods);
  const upd = (i, k, v) => setList(list.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  const add = () => setList([...list, { id: `pm_${Date.now().toString(36)}`, name: "New bank", account_name: "", account_number: "", phone: "", branch: "" }]);
  return (
    <div className="space-y-6">
      <p className="text-sm text-muted-foreground">These accounts are shown to members on their payment page and in the payment method list. Leave a field empty to hide it.</p>
      {list.map((m, i) => (
        <Group key={m.id} title={m.name || "Untitled"}>
          <div className="flex justify-end"><RowTools onUp={() => setList(move(list, i, -1))} onDown={() => setList(move(list, i, 1))} onDelete={() => setList(list.filter((_, j) => j !== i))} testId={`pm-${m.id}`} /></div>
          <div className="grid gap-4 md:grid-cols-2">
            <Field label="Bank / method name" value={m.name} onChange={(v) => upd(i, "name", v)} testId={`pm-${m.id}-name-input`} />
            <Field label="Account holder name" value={m.account_name} onChange={(v) => upd(i, "account_name", v)} testId={`pm-${m.id}-account-name-input`} />
            <Field label="Account number" value={m.account_number} onChange={(v) => upd(i, "account_number", v)} testId={`pm-${m.id}-account-number-input`} />
            <Field label="Phone number (e.g. Telebirr)" value={m.phone} onChange={(v) => upd(i, "phone", v)} testId={`pm-${m.id}-phone-input`} />
            <Field label="Branch (optional)" value={m.branch} onChange={(v) => upd(i, "branch", v)} testId={`pm-${m.id}-branch-input`} />
          </div>
        </Group>
      ))}
      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={add} className="btn-ghost-gold" data-testid="pm-add-btn"><Plus className="h-4 w-4" />Add bank / method</button>
        <SaveBar onClick={() => save({ payment_methods: list.map((m) => ({ ...m, name: m.name.trim() || "Bank" })) })} busy={busy} testId="payments-save-btn" />
      </div>
    </div>
  );
};
